<template>
  <v-container>
    <v-row justify="center" class="mt-0">
      <v-col class="py-0">
        <v-card
          class="buyorder-list-width helmi-card"
        >
          <div class="helmi-card-title pt-6 pl-6">
            Ostotoimeksiannot
          </div>
          <v-card-text :class="{ 'px-6': $vuetify.breakpoint.mdAndUp }" class="pt-0">
            <v-row
              align="center"
              class="mx-0 mt-4 no-wrap"
            >
              <v-select
                v-model="show"
                :items="showTypes"
                label="Näytä"
                outlined
                dense
                hide-details
              />
              <v-btn
                class="ml-2"
                depressed
                color="primary"
                @click="newBuyOrder()"
              >
                Luo uusi
              </v-btn>
            </v-row>
          </v-card-text>
          <v-list
            two-line
            subheader
            class="pb-0 mt-4"
          >
            <template
              v-for="item in buyOrders"
            >
              <v-list-item
                :key="item.id"
                class="px-6"
                @click="openBuyOrder(item.id)"
              >
                <v-list-item-avatar>
                  <v-icon
                    class="white--text"
                    :class="item.status === '3' ? 'warning' : 'primary'"
                  >
                    assignment
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.readable_property_type }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span :class="{ 'red--text' : isInThePast(item.ends) && +item.status === 1 }">
                      {{ formatDate(item.created) }} - {{ formatDate(item.ends) }}
                    </span><br>
                    <span
                      v-for="(person, index) in item.persons"
                      :key="index"
                      class="text-caption"
                    >
                      {{ index > 0 ? `- ${person.nimi}` : person.nimi }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text class="grey--text">
                    #{{ item.ordernumber }}
                  </v-list-item-action-text>
                  <v-list-item-subtitle
                    :class="item.status === '3' ? 'warning--text' : 'primary--text'"
                  >
                    {{ getStatus(item.status) }}
                  </v-list-item-subtitle>
                  <v-list-item-action-text class="grey--text">
                    {{ item.region }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`${item.id}_`"/>
            </template>
            <v-list-item v-if="!buyOrders.length" class="px-6">
              Ei ostotoimeksiantoja
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment';
import { apiGet } from '../api';

export default {
  data: () => ({
    buyOrders: [],
    show: '5',
    showTypes: [{
      value: '5',
      text: 'Aktiiviset + luonnokset',
    }, {
      value: '1',
      text: 'Aktiiviset',
    }, {
      value: '4',
      text: 'Luonnokset',
    }, {
      value: '3',
      text: 'Toteutuneet',
    }, {
      value: '2',
      text: 'Päättyneet',
    }, {
      value: '0',
      text: 'Kaikki',
    }],
  }),
  watch: {
    show: {
      async handler() {
        this.getBuyOrders();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getBuyOrders();
  },
  methods: {
    async getBuyOrders() {
      const response = await apiGet(`buyorders/list/${this.show}`);
      this.buyOrders = response.result;
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format('DD.MM.YYYY');
    },
    isInThePast(date) {
      return moment(date) < new Date();
    },
    openBuyOrder(id) {
      this.$router.push(`/${this.$route.params.companyId}/buyorders/${id}`);
    },
    newBuyOrder() {
      this.$router.push(`/${this.$route.params.companyId}/buyorders/new`);
    },
    getStatus(value) {
      const status = {
        0: 'Päätetty',
        1: 'Aktiivinen',
        2: 'Toteutunut',
        3: 'Luonnos',
      };
      return status[value];
    },
  },
};
</script>
<style lang="scss">
  .no-wrap {
    flex-wrap: nowrap !important;
  }
  .buyorder-list-width {
    // min-width: 100%;
  }
</style>
